import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoutesCommon } from '@conf';
import { ErrorsHandlerGuard } from '@lib/guards/errors-handler.guard';
import { CHECKIN_ROUTES } from '@conf/routes.config';
import { CheckinSearchGuard, InputPassengerInformationGuard } from 'src/guards';
import { CheckinCommonClearGuard } from 'src/guards/checkin-common-clear.guard';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: `${RoutesCommon.COMMON}/:type`,
        canActivate: [ErrorsHandlerGuard, CheckinCommonClearGuard],
        loadChildren: () =>
          import('@lib/components/shared-ui-components/common-error/container/common-error-cont.module').then(
            (m) => m.CommonErrorContModule
          ),
      },
      {
        path: CHECKIN_ROUTES.checkinSearch,
        loadChildren: () =>
          import('./checkin-search/container/checkin-search.module').then((m) => m.CheckinSearchModule),
        canActivate: [CheckinSearchGuard],
      },
      {
        path: CHECKIN_ROUTES.checkinSelect,
        loadChildren: () => import('./checkin-select').then((m) => m.CheckinSelectModule),
      },
      {
        path: CHECKIN_ROUTES.passengerInput,
        loadChildren: () => import('./checkin-passenger-input').then((m) => m.CheckinPassengerInputModule),
        canActivate: [InputPassengerInformationGuard],
      },
      {
        path: CHECKIN_ROUTES.seatmap,
        loadChildren: () => import('./checkin-seatmap').then((m) => m.CheckinSeatmapModule),
      },
      {
        path: CHECKIN_ROUTES.checkinMybooking,
        loadChildren: () => import('./checkin-mybooking').then((m) => m.CheckinMybookingContModule),
      },
      {
        path: CHECKIN_ROUTES.checkinCompleted,
        loadChildren: () => import('./checkin-completed').then((m) => m.CheckinCompletedModule),
      },
      {
        path: CHECKIN_ROUTES.checkinReview,
        loadChildren: () => import('./checkin-review').then((m) => m.CheckinReviewModule),
      },
      {
        path: CHECKIN_ROUTES.waitingSearch,
        loadChildren: () => import('./checkin-waiting-search').then((m) => m.CheckinWaitingSearchModule),
      },
      {
        path: CHECKIN_ROUTES.waitingNumber,
        loadChildren: () => import('./checkin-waiting-number').then((m) => m.CheckinWaitingNumberModule),
      },
      {
        path: CHECKIN_ROUTES.standbyFlightAvailability,
        loadChildren: () =>
          import('./checkin-standby-flight-availability').then((m) => m.CheckinStandbyFlightAvailabilityModule),
      },
      {
        path: CHECKIN_ROUTES.standbyReview,
        loadChildren: () => import('./checkin-standby-review').then((m) => m.CheckinStandbyReviewModule),
      },
      {
        path: CHECKIN_ROUTES.standbyCompleted,
        loadChildren: () => import('./checkin-standby-completed').then((m) => m.CheckinStandbyCompletedModule),
      },
      {
        path: '**',
        redirectTo: `/${RoutesCommon.SYSTEM_ERROR}`,
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { urlUpdateStrategy: 'eager', onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
